module.exports = __webpack_public_path__ + "img/3dbf46a.svg";